/**
 * Prevent markdown from collapsing whitespace by prepending newline characters with two spaces.
 * @param markdownString
 * @returns A markdown string with newline characters prepended with two spaces.
 */
export const preserveNewlines = (markdownString: string) => {
    return markdownString.replace(/\n/gi, " &nbsp;\n");
};
